<template>
    <div>
        <br>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <date-picker v-model="search.date"
                             range
                             placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด"
                             :format="changeFormat"
                             :lang="lang" confirm>
                </date-picker>
                &nbsp;
                <button type="button" class="btn btn-success" @click="getDriverTransportReportTable">
                    <icon name="search"></icon>
                    ค้นหา
                </button>
                &nbsp;
                <button type="button" class="btn btn-info" @click="showDriverTransportReportModal">
                    <icon name="print"></icon>
                    รายงานบันทึกค่าเที่ยว
                </button>
                &nbsp;
                <button type="button" class="btn btn-info" @click="showReportModal">
                    <icon name="print"></icon>
                    รายงานภาษี 1%
                </button>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">วัน-เวลาเริ่มต้น</th>
                    <th scope="col">วัน-เวลาสิ้นสุด</th>
                    <th scope="col">ยอดเงินรับ</th>
                    <th scope="col">หักจ่ายค่าเที่ยว</th>
                    <th scope="col">หักจ่ายเบ็ดเตล็ด</th>
                    <th scope="col">คงเหลือ</th>
                    <th scope="col">ภาษี 1%</th>
                    <th scope="col">ผู้บันทึกข้อมูล</th>
                    <th scope="col">ผู้แก้ไขข้อมูล</th>
                    <th scope="col">แก้ไขข้อมูล</th>
                    <th scope="col">พิมพ์ข้อมูล</th>
                    <th scope="col" v-if="canViewSuperAdmin">ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in tableList">
                    <td>{{ ((dataPaginate.current_page - 1) * 10) + (index + 1) }}</td>
                    <td>
                        {{ data.start_date ? data.start_date : '' | moment('DD/MM/YYYY') }} {{ data.start_time }}
                    </td>
                    <td>
                        {{ data.end_date ? data.end_date : '' | moment('DD/MM/YYYY') }} {{ data.end_time }}
                    </td>
                    <td>{{ data.total_income ? data.total_income : 0 | currency }}</td>
                    <td>{{ data.transport_cost ? data.transport_cost : 0 | currency }}</td>
                    <td>{{ data.other_withdraw ? data.other_withdraw : 0 | currency }}</td>
                    <td>{{ data.balance ? data.balance : 0 | currency }}</td>
                    <td>{{ data.tax ? data.tax : 0 | currency }}</td>
                    <td>{{ data.user ? data.user.name : '' }}</td>
                    <td>{{ data.user_update ? data.user_update.name : '' }}</td>
                    <td>
                        <button class="btn btn-info" type="button" @click="showDriverTransportReport(data.id)">
                            <icon name="pencil-alt"></icon>
                            แก้ไขข้อมูล
                        </button>
                    </td>
                    <td>
                        <button class="btn btn-primary" type="button" @click="printReport(data.id)">
                            <icon name="print"></icon>
                            พิมพ์ข้อมูล
                        </button>
                    </td>
                    <td v-if="canViewSuperAdmin">
                        <button type="button" class="btn btn-danger"
                                @click="showDelteModal(data.id)">
                            <icon name="trash"></icon>
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <br/>
        <div v-if="tableList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getDriverTransportReportTable">
            </vue-pagination>
        </div>
        <b-modal hide-footer
                 title="รายงานบันทึกค่าเที่ยว"
                 ref="driver_transport_report">
            <driver-transport-report-modal @submit="PrintAndSaveDriverTransportReport" :form="form">
            </driver-transport-report-modal>
        </b-modal>
        <b-modal hide-footer
                 title="รายงานภาษี 1%"
                 ref="transport_report">
            <div class="row form-group">
                <div class="col-4">
                    วันที่ - เวลาเริ่มต้น
                </div>
                <div class="col-8">
                    <date-picker
                        v-model="report.start_date"
                        type="datetime"
                        :format="changeFormat"
                        :lang="lang"
                        confirm
                        class="w-100"
                        placeholder="วันที่เริ่มต้น">
                    </date-picker>
                </div>
            </div>
            <div class="row form-group">
                <div class="col-4">
                    วันที่ - เวลาสิ้นสุด
                </div>
                <div class="col-8">
                    <date-picker
                        v-model="report.end_date"
                        type="datetime"
                        :format="changeFormat"
                        :lang="lang"
                        confirm
                        class="w-100"
                        placeholder="วันที่สิ้นสุด">
                    </date-picker>
                </div>
            </div>
            <div class="row">
                <div class="col offset-5">
                    <button
                        type="button"
                        class="btn btn-success"
                        @click="printOnePercent">
                        พิมพ์
                    </button>
                </div>
            </div>
        </b-modal>
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button
                    type="button"
                    class="btn btn-success"
                    @click="removeData">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hideDeleteModal">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!--        <pre class="alert-danger">{{form}}</pre>-->
    </div>
</template>

<script>
import moment from 'moment';
import {domain} from "../../../util/Constants";
import DriverTransportReportModal from "./DriverTransportReportModal";
import {mapState} from "vuex";
import DatePicker from 'vue2-datepicker'
import VuePagination from "../../Pagination";
import {canViewSuperAdmin} from '../../../util/Permissions';

export default {
    name: "DriverTransportReportList",
    components: {VuePagination, DriverTransportReportModal, DatePicker},
    data() {
        return {
            search: {
                date: []
            },
            form: {
                id: '',
                income: '',
                income_before: '',
                other_withdraw: '',
                start_date: '',
                end_date: '',
                start_time: '',
                end_time: '',
                reason: '',
            },
            report: {
                start_date: '',
                end_date: ''
            },
            tableList: [],
            dataPaginate: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year+' HH:mm:ss'));
                    return date ? moment(date).format('DD/MM/' + year + ' HH:mm:ss') : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY HH:mm:ss').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            deleted_id: '',
        }
    },
    computed: {
        ...mapState({
            canViewSuperAdmin,
            user: state => {
                return state.Auth.user;
            },
        }),
    },
    created() {
        this.getDriverTransportReportTable();
    },
    methods: {
        printOnePercent() {
            let data = {
                start: moment(this.report.start_date).format('YYYY-MM-DD hh:mm:ss'),
                end: moment(this.report.end_date).format('YYYY-MM-DD hh:mm:ss'),
            }
            window.open(domain + `/one_percent_report?start_date=${data.start}&end_date=${data.end}`, '_blank')
        },
        showDelteModal(id) {
            this.deleted_id = id;
            this.$refs.delete_item.show();
        },
        hideDeleteModal() {
            this.$refs.delete_item.hide();
        },
        removeData() {
            this.$store.dispatch("DriverDetails/deleteDriverTransport", this.deleted_id).then(() => {
                this.hideDeleteModal();
                this.getDriverTransportReportTable();
            })
        },
        showDriverTransportReportModal() {
            if (!this.form.id) {
                this.$store.dispatch("DriverDetails/getBalanceDriverTransport").then(res => {
                    this.form.income_before = res;
                })
            }
            this.$refs.driver_transport_report.show();
        },
        showReportModal() {
            this.$refs.transport_report.show();
        },
        hideDriverTransportReportModal() {
            this.$refs.driver_transport_report.hide();
        },
        showDriverTransportReport(id) {
            this.$store.dispatch("DriverDetails/showDriverTransportReport", id).then(res => {
                this.form.id = res.id;
                this.form.income = res.income;
                this.form.income_before = res.income_before;
                this.form.other_withdraw = res.other_withdraw;
                this.form.start_date = res.start_date;
                this.form.end_date = res.end_date;
                this.form.end_time = new Date(res.end_date + ' ' + res.end_time);
                this.form.start_time = new Date(res.start_date + ' ' + res.start_time);
                this.form.reason = res.reason;
                this.showDriverTransportReportModal();
            })
        },
        PrintAndSaveDriverTransportReport(submit) {
            if (submit) {
                let start_date = submit.start_date ? moment(submit.start_date).format('YYYY-MM-DD') : '';
                let end_date = submit.end_date ? moment(submit.end_date).format('YYYY-MM-DD') : '';
                let start_time = submit.start_time ? moment(submit.start_time).format('HH:mm:ss') : '';
                let end_time = submit.end_time ? moment(submit.end_time).format('HH:mm:ss') : '';
                //console.log(submit);
                let data = {
                    id: submit.id,
                    income: submit.income,
                    income_before: submit.income_before,
                    other_withdraw: submit.other_withdraw,
                    start_date,
                    end_date,
                    start_time,
                    end_time,
                    user_id: this.user.id,
                    reason: submit.reason,
                }
                this.$store.dispatch("DriverDetails/saveDriverTransportReport", {
                    id: data.id,
                    data: data
                }).then(res => {
                    if (res) {
                        this.getDriverTransportReportTable();
                        this.printReport(res.id);
                        location.reload();
                    } else {
                        alert("บันทึกไม่สำเร็จ");
                    }
                }).catch(err => {
                    alert("บันทึกไม่สำเร็จ");
                })
            }
            this.form = {
                id: '',
                income: '',
                income_before: '',
                other_withdraw: '',
                start_date: '',
                end_date: '',
                start_time: '',
                end_time: '',
                reason: '',
            };
            this.hideDriverTransportReportModal();
        },
        printReport(id) {
            window.open(domain + "/driver_transport_report?id=" + id);
        },
        getDriverTransportReportTable() {
            let start_date = '';
            let end_date = '';
            if (this.search.date.length > 0 && this.search.date[0]) {
                start_date = moment(this.search.date[0]).format('YYYY-MM-DD');
                end_date = moment(this.search.date[1]).format('YYYY-MM-DD');
            }
            let data = {
                page: this.dataPaginate.current_page,
                start_date,
                end_date
            };
            this.$store.dispatch("DriverDetails/getDriverTransportReport", data).then(res => {
                this.tableList = res.data;
                this.dataPaginate = {
                    current_page: res.current_page,
                    from: res.from,
                    last_page: res.last_page,
                    per_page: res.per_page,
                    total: res.total,
                    to: res.to
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
